import React from "react";
import PropTypes from "prop-types";
import MainFrameContainer from "./MainFrameContainer";
import OvFilterPanelContainer from "./OvFilterPanelContainer";
import OvToggleFilterPanelContainer from "./OvToggleFilterPanelContainer";

import OvSubbarContainer from "./OvSubbarContainer";
import OvSectionRouter from "./OvSectionRouter";

const appBarHeight = 100;

const Overview = props => {
  const { tabLabel, filterPanelVisible } = props;

  return (
    <MainFrameContainer
      appBarHeight={appBarHeight}
      title="Overview"
      body={<OvSectionRouter />}
      subBar={
        <OvSubbarContainer
          secondaryControl={<OvToggleFilterPanelContainer />}
        />
      }
      sidebar={<OvFilterPanelContainer tabLabel={tabLabel} />}
      sidebarOpen={filterPanelVisible}
    />
  );
};

Overview.propTypes = {
  filterPanelVisible: PropTypes.bool.isRequired,
  tabLabel: PropTypes.string
};

export default Overview;



// WEBPACK FOOTER //
// ./src/Overview.js